export type BringgFontIconsId =
  | "accelerate"
  | "add-location-alt"
  | "alt-route"
  | "analytics-chart"
  | "analytics"
  | "area-chart"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "arrow-up"
  | "arrow"
  | "arrows-up-down"
  | "attachment"
  | "auto-stories"
  | "autopay"
  | "barcode"
  | "bars-filter"
  | "battery-full"
  | "battery-ver-empty"
  | "battery-ver-half"
  | "battery-ver-quarter"
  | "battery-ver-three-quarters"
  | "bicycle"
  | "block"
  | "break-to"
  | "bringg"
  | "bullseye"
  | "bus"
  | "business"
  | "busket"
  | "cafe-solid"
  | "cafe"
  | "calendar"
  | "campaign"
  | "cancel"
  | "capacity"
  | "car"
  | "cart"
  | "cashier"
  | "chat-bubble"
  | "chat-bubbles"
  | "checklist"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "chevron"
  | "chevrons-end"
  | "chevrons-start"
  | "circle-exclamation"
  | "circle-plus"
  | "circle"
  | "clock-light"
  | "clock"
  | "close-circle"
  | "close"
  | "coins"
  | "colorize"
  | "columns"
  | "compare"
  | "compass"
  | "completed"
  | "connected-hub"
  | "control-tower"
  | "copy"
  | "create-route-plus"
  | "create-route"
  | "credit-card"
  | "crew"
  | "csv-file"
  | "cube"
  | "customer-sdk"
  | "customer"
  | "cutoff"
  | "delivery-blocks"
  | "delivery-slots"
  | "deployed-code-history"
  | "design-services"
  | "dispatch"
  | "dispatchers"
  | "distance"
  | "distribution-hub"
  | "documenatation-link"
  | "document"
  | "done-planning"
  | "dot"
  | "download"
  | "drag"
  | "driver-home"
  | "drivers-returning-to-base"
  | "drivers"
  | "dropoff"
  | "eco"
  | "edit-square"
  | "erase"
  | "event-available"
  | "expenses"
  | "export"
  | "external-id"
  | "external-link"
  | "eye-off"
  | "eye"
  | "feather"
  | "file-alt"
  | "file-import"
  | "file"
  | "filter-hdr"
  | "filter-list"
  | "flat-tire"
  | "floating-inventory"
  | "fork-left-right-back"
  | "forward"
  | "fragile"
  | "freeze"
  | "functions"
  | "globe"
  | "go-to-link"
  | "graph-overview"
  | "graph"
  | "group-by"
  | "hamburger"
  | "hand-pan-move"
  | "hand-pointing-up"
  | "headset"
  | "heart-filled"
  | "heart"
  | "help"
  | "home"
  | "hourglass"
  | "hub"
  | "info-filled"
  | "info"
  | "inventory"
  | "json"
  | "keyboard"
  | "launch"
  | "layers"
  | "leaf-eco"
  | "library-books"
  | "link"
  | "list"
  | "loader"
  | "local-police"
  | "local-shipping"
  | "location"
  | "lock"
  | "locker"
  | "logout"
  | "man"
  | "manage-history"
  | "map-task"
  | "map"
  | "maximize"
  | "menu-horizontal"
  | "menu"
  | "message-mail"
  | "minimize"
  | "minus"
  | "mobile-action-complete-form"
  | "mobile-action-question"
  | "monitor"
  | "move-to-dispatch"
  | "move-to-planning"
  | "my-location"
  | "navigation-up"
  | "navigation"
  | "no-vehicle"
  | "note-light"
  | "notes"
  | "notification"
  | "open-in-new"
  | "optimize"
  | "order"
  | "ordered-list"
  | "package"
  | "pallets"
  | "parking-location"
  | "partner-exchange"
  | "pause"
  | "pdf-file"
  | "pencil"
  | "phone-android"
  | "phone"
  | "pickup"
  | "planning"
  | "play"
  | "plus"
  | "power"
  | "preferences"
  | "preparation-restaurant"
  | "preperation"
  | "print"
  | "promped-message"
  | "puzzle"
  | "radar"
  | "recipt"
  | "redo-arrow"
  | "redo"
  | "reload"
  | "report"
  | "reschedule"
  | "resources"
  | "revenues"
  | "reviews"
  | "ro-simulator"
  | "rotate"
  | "route-identifier"
  | "route"
  | "ruler"
  | "save-as"
  | "save"
  | "scanner"
  | "search"
  | "selected-outline"
  | "selected"
  | "send"
  | "service-areas"
  | "settings-suggest"
  | "settings"
  | "share"
  | "sheet-with-dollar"
  | "shield-person"
  | "show-less"
  | "show-more"
  | "skills"
  | "small-circle"
  | "sort-asc"
  | "sort-desc"
  | "sparkles"
  | "star"
  | "sticky-note"
  | "stop-circle"
  | "store"
  | "suffix"
  | "suitcase"
  | "support"
  | "takeout-dining"
  | "task-alt"
  | "team-home"
  | "team-parking"
  | "team"
  | "text-bold"
  | "text-italic"
  | "text-underline"
  | "ticket"
  | "traffic"
  | "trailer"
  | "trash"
  | "tree"
  | "truck"
  | "unassigned"
  | "unavailable"
  | "undo-arrow"
  | "undo"
  | "unuser"
  | "upload"
  | "user"
  | "users"
  | "verification-code"
  | "warehouse"
  | "warning-circle"
  | "warning-not-filled"
  | "warning"
  | "weight"
  | "wheel"
  | "zoom-in"
  | "zoom-out";

export type BringgFontIconsKey =
  | "Accelerate"
  | "AddLocationAlt"
  | "AltRoute"
  | "AnalyticsChart"
  | "Analytics"
  | "AreaChart"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowUp"
  | "Arrow"
  | "ArrowsUpDown"
  | "Attachment"
  | "AutoStories"
  | "Autopay"
  | "Barcode"
  | "BarsFilter"
  | "BatteryFull"
  | "BatteryVerEmpty"
  | "BatteryVerHalf"
  | "BatteryVerQuarter"
  | "BatteryVerThreeQuarters"
  | "Bicycle"
  | "Block"
  | "BreakTo"
  | "Bringg"
  | "Bullseye"
  | "Bus"
  | "Business"
  | "Busket"
  | "CafeSolid"
  | "Cafe"
  | "Calendar"
  | "Campaign"
  | "Cancel"
  | "Capacity"
  | "Car"
  | "Cart"
  | "Cashier"
  | "ChatBubble"
  | "ChatBubbles"
  | "Checklist"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "Chevron"
  | "ChevronsEnd"
  | "ChevronsStart"
  | "CircleExclamation"
  | "CirclePlus"
  | "Circle"
  | "ClockLight"
  | "Clock"
  | "CloseCircle"
  | "Close"
  | "Coins"
  | "Colorize"
  | "Columns"
  | "Compare"
  | "Compass"
  | "Completed"
  | "ConnectedHub"
  | "ControlTower"
  | "Copy"
  | "CreateRoutePlus"
  | "CreateRoute"
  | "CreditCard"
  | "Crew"
  | "CsvFile"
  | "Cube"
  | "CustomerSdk"
  | "Customer"
  | "Cutoff"
  | "DeliveryBlocks"
  | "DeliverySlots"
  | "DeployedCodeHistory"
  | "DesignServices"
  | "Dispatch"
  | "Dispatchers"
  | "Distance"
  | "DistributionHub"
  | "DocumenatationLink"
  | "Document"
  | "DonePlanning"
  | "Dot"
  | "Download"
  | "Drag"
  | "DriverHome"
  | "DriversReturningToBase"
  | "Drivers"
  | "Dropoff"
  | "Eco"
  | "EditSquare"
  | "Erase"
  | "EventAvailable"
  | "Expenses"
  | "Export"
  | "ExternalId"
  | "ExternalLink"
  | "EyeOff"
  | "Eye"
  | "Feather"
  | "FileAlt"
  | "FileImport"
  | "File"
  | "FilterHdr"
  | "FilterList"
  | "FlatTire"
  | "FloatingInventory"
  | "ForkLeftRightBack"
  | "Forward"
  | "Fragile"
  | "Freeze"
  | "Functions"
  | "Globe"
  | "GoToLink"
  | "GraphOverview"
  | "Graph"
  | "GroupBy"
  | "Hamburger"
  | "HandPanMove"
  | "HandPointingUp"
  | "Headset"
  | "HeartFilled"
  | "Heart"
  | "Help"
  | "Home"
  | "Hourglass"
  | "Hub"
  | "InfoFilled"
  | "Info"
  | "Inventory"
  | "Json"
  | "Keyboard"
  | "Launch"
  | "Layers"
  | "LeafEco"
  | "LibraryBooks"
  | "Link"
  | "List"
  | "Loader"
  | "LocalPolice"
  | "LocalShipping"
  | "Location"
  | "Lock"
  | "Locker"
  | "Logout"
  | "Man"
  | "ManageHistory"
  | "MapTask"
  | "Map"
  | "Maximize"
  | "MenuHorizontal"
  | "Menu"
  | "MessageMail"
  | "Minimize"
  | "Minus"
  | "MobileActionCompleteForm"
  | "MobileActionQuestion"
  | "Monitor"
  | "MoveToDispatch"
  | "MoveToPlanning"
  | "MyLocation"
  | "NavigationUp"
  | "Navigation"
  | "NoVehicle"
  | "NoteLight"
  | "Notes"
  | "Notification"
  | "OpenInNew"
  | "Optimize"
  | "Order"
  | "OrderedList"
  | "Package"
  | "Pallets"
  | "ParkingLocation"
  | "PartnerExchange"
  | "Pause"
  | "PdfFile"
  | "Pencil"
  | "PhoneAndroid"
  | "Phone"
  | "Pickup"
  | "Planning"
  | "Play"
  | "Plus"
  | "Power"
  | "Preferences"
  | "PreparationRestaurant"
  | "Preperation"
  | "Print"
  | "PrompedMessage"
  | "Puzzle"
  | "Radar"
  | "Recipt"
  | "RedoArrow"
  | "Redo"
  | "Reload"
  | "Report"
  | "Reschedule"
  | "Resources"
  | "Revenues"
  | "Reviews"
  | "RoSimulator"
  | "Rotate"
  | "RouteIdentifier"
  | "Route"
  | "Ruler"
  | "SaveAs"
  | "Save"
  | "Scanner"
  | "Search"
  | "SelectedOutline"
  | "Selected"
  | "Send"
  | "ServiceAreas"
  | "SettingsSuggest"
  | "Settings"
  | "Share"
  | "SheetWithDollar"
  | "ShieldPerson"
  | "ShowLess"
  | "ShowMore"
  | "Skills"
  | "SmallCircle"
  | "SortAsc"
  | "SortDesc"
  | "Sparkles"
  | "Star"
  | "StickyNote"
  | "StopCircle"
  | "Store"
  | "Suffix"
  | "Suitcase"
  | "Support"
  | "TakeoutDining"
  | "TaskAlt"
  | "TeamHome"
  | "TeamParking"
  | "Team"
  | "TextBold"
  | "TextItalic"
  | "TextUnderline"
  | "Ticket"
  | "Traffic"
  | "Trailer"
  | "Trash"
  | "Tree"
  | "Truck"
  | "Unassigned"
  | "Unavailable"
  | "UndoArrow"
  | "Undo"
  | "Unuser"
  | "Upload"
  | "User"
  | "Users"
  | "VerificationCode"
  | "Warehouse"
  | "WarningCircle"
  | "WarningNotFilled"
  | "Warning"
  | "Weight"
  | "Wheel"
  | "ZoomIn"
  | "ZoomOut";

export enum BringgFontIcons {
  Accelerate = "accelerate",
  AddLocationAlt = "add-location-alt",
  AltRoute = "alt-route",
  AnalyticsChart = "analytics-chart",
  Analytics = "analytics",
  AreaChart = "area-chart",
  ArrowDown = "arrow-down",
  ArrowLeft = "arrow-left",
  ArrowRight = "arrow-right",
  ArrowUp = "arrow-up",
  Arrow = "arrow",
  ArrowsUpDown = "arrows-up-down",
  Attachment = "attachment",
  AutoStories = "auto-stories",
  Autopay = "autopay",
  Barcode = "barcode",
  BarsFilter = "bars-filter",
  BatteryFull = "battery-full",
  BatteryVerEmpty = "battery-ver-empty",
  BatteryVerHalf = "battery-ver-half",
  BatteryVerQuarter = "battery-ver-quarter",
  BatteryVerThreeQuarters = "battery-ver-three-quarters",
  Bicycle = "bicycle",
  Block = "block",
  BreakTo = "break-to",
  Bringg = "bringg",
  Bullseye = "bullseye",
  Bus = "bus",
  Business = "business",
  Busket = "busket",
  CafeSolid = "cafe-solid",
  Cafe = "cafe",
  Calendar = "calendar",
  Campaign = "campaign",
  Cancel = "cancel",
  Capacity = "capacity",
  Car = "car",
  Cart = "cart",
  Cashier = "cashier",
  ChatBubble = "chat-bubble",
  ChatBubbles = "chat-bubbles",
  Checklist = "checklist",
  ChevronLeft = "chevron-left",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  Chevron = "chevron",
  ChevronsEnd = "chevrons-end",
  ChevronsStart = "chevrons-start",
  CircleExclamation = "circle-exclamation",
  CirclePlus = "circle-plus",
  Circle = "circle",
  ClockLight = "clock-light",
  Clock = "clock",
  CloseCircle = "close-circle",
  Close = "close",
  Coins = "coins",
  Colorize = "colorize",
  Columns = "columns",
  Compare = "compare",
  Compass = "compass",
  Completed = "completed",
  ConnectedHub = "connected-hub",
  ControlTower = "control-tower",
  Copy = "copy",
  CreateRoutePlus = "create-route-plus",
  CreateRoute = "create-route",
  CreditCard = "credit-card",
  Crew = "crew",
  CsvFile = "csv-file",
  Cube = "cube",
  CustomerSdk = "customer-sdk",
  Customer = "customer",
  Cutoff = "cutoff",
  DeliveryBlocks = "delivery-blocks",
  DeliverySlots = "delivery-slots",
  DeployedCodeHistory = "deployed-code-history",
  DesignServices = "design-services",
  Dispatch = "dispatch",
  Dispatchers = "dispatchers",
  Distance = "distance",
  DistributionHub = "distribution-hub",
  DocumenatationLink = "documenatation-link",
  Document = "document",
  DonePlanning = "done-planning",
  Dot = "dot",
  Download = "download",
  Drag = "drag",
  DriverHome = "driver-home",
  DriversReturningToBase = "drivers-returning-to-base",
  Drivers = "drivers",
  Dropoff = "dropoff",
  Eco = "eco",
  EditSquare = "edit-square",
  Erase = "erase",
  EventAvailable = "event-available",
  Expenses = "expenses",
  Export = "export",
  ExternalId = "external-id",
  ExternalLink = "external-link",
  EyeOff = "eye-off",
  Eye = "eye",
  Feather = "feather",
  FileAlt = "file-alt",
  FileImport = "file-import",
  File = "file",
  FilterHdr = "filter-hdr",
  FilterList = "filter-list",
  FlatTire = "flat-tire",
  FloatingInventory = "floating-inventory",
  ForkLeftRightBack = "fork-left-right-back",
  Forward = "forward",
  Fragile = "fragile",
  Freeze = "freeze",
  Functions = "functions",
  Globe = "globe",
  GoToLink = "go-to-link",
  GraphOverview = "graph-overview",
  Graph = "graph",
  GroupBy = "group-by",
  Hamburger = "hamburger",
  HandPanMove = "hand-pan-move",
  HandPointingUp = "hand-pointing-up",
  Headset = "headset",
  HeartFilled = "heart-filled",
  Heart = "heart",
  Help = "help",
  Home = "home",
  Hourglass = "hourglass",
  Hub = "hub",
  InfoFilled = "info-filled",
  Info = "info",
  Inventory = "inventory",
  Json = "json",
  Keyboard = "keyboard",
  Launch = "launch",
  Layers = "layers",
  LeafEco = "leaf-eco",
  LibraryBooks = "library-books",
  Link = "link",
  List = "list",
  Loader = "loader",
  LocalPolice = "local-police",
  LocalShipping = "local-shipping",
  Location = "location",
  Lock = "lock",
  Locker = "locker",
  Logout = "logout",
  Man = "man",
  ManageHistory = "manage-history",
  MapTask = "map-task",
  Map = "map",
  Maximize = "maximize",
  MenuHorizontal = "menu-horizontal",
  Menu = "menu",
  MessageMail = "message-mail",
  Minimize = "minimize",
  Minus = "minus",
  MobileActionCompleteForm = "mobile-action-complete-form",
  MobileActionQuestion = "mobile-action-question",
  Monitor = "monitor",
  MoveToDispatch = "move-to-dispatch",
  MoveToPlanning = "move-to-planning",
  MyLocation = "my-location",
  NavigationUp = "navigation-up",
  Navigation = "navigation",
  NoVehicle = "no-vehicle",
  NoteLight = "note-light",
  Notes = "notes",
  Notification = "notification",
  OpenInNew = "open-in-new",
  Optimize = "optimize",
  Order = "order",
  OrderedList = "ordered-list",
  Package = "package",
  Pallets = "pallets",
  ParkingLocation = "parking-location",
  PartnerExchange = "partner-exchange",
  Pause = "pause",
  PdfFile = "pdf-file",
  Pencil = "pencil",
  PhoneAndroid = "phone-android",
  Phone = "phone",
  Pickup = "pickup",
  Planning = "planning",
  Play = "play",
  Plus = "plus",
  Power = "power",
  Preferences = "preferences",
  PreparationRestaurant = "preparation-restaurant",
  Preperation = "preperation",
  Print = "print",
  PrompedMessage = "promped-message",
  Puzzle = "puzzle",
  Radar = "radar",
  Recipt = "recipt",
  RedoArrow = "redo-arrow",
  Redo = "redo",
  Reload = "reload",
  Report = "report",
  Reschedule = "reschedule",
  Resources = "resources",
  Revenues = "revenues",
  Reviews = "reviews",
  RoSimulator = "ro-simulator",
  Rotate = "rotate",
  RouteIdentifier = "route-identifier",
  Route = "route",
  Ruler = "ruler",
  SaveAs = "save-as",
  Save = "save",
  Scanner = "scanner",
  Search = "search",
  SelectedOutline = "selected-outline",
  Selected = "selected",
  Send = "send",
  ServiceAreas = "service-areas",
  SettingsSuggest = "settings-suggest",
  Settings = "settings",
  Share = "share",
  SheetWithDollar = "sheet-with-dollar",
  ShieldPerson = "shield-person",
  ShowLess = "show-less",
  ShowMore = "show-more",
  Skills = "skills",
  SmallCircle = "small-circle",
  SortAsc = "sort-asc",
  SortDesc = "sort-desc",
  Sparkles = "sparkles",
  Star = "star",
  StickyNote = "sticky-note",
  StopCircle = "stop-circle",
  Store = "store",
  Suffix = "suffix",
  Suitcase = "suitcase",
  Support = "support",
  TakeoutDining = "takeout-dining",
  TaskAlt = "task-alt",
  TeamHome = "team-home",
  TeamParking = "team-parking",
  Team = "team",
  TextBold = "text-bold",
  TextItalic = "text-italic",
  TextUnderline = "text-underline",
  Ticket = "ticket",
  Traffic = "traffic",
  Trailer = "trailer",
  Trash = "trash",
  Tree = "tree",
  Truck = "truck",
  Unassigned = "unassigned",
  Unavailable = "unavailable",
  UndoArrow = "undo-arrow",
  Undo = "undo",
  Unuser = "unuser",
  Upload = "upload",
  User = "user",
  Users = "users",
  VerificationCode = "verification-code",
  Warehouse = "warehouse",
  WarningCircle = "warning-circle",
  WarningNotFilled = "warning-not-filled",
  Warning = "warning",
  Weight = "weight",
  Wheel = "wheel",
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
}

export const BRINGG_FONT_ICONS_CODEPOINTS: { [key in BringgFontIcons]: string } = {
  [BringgFontIcons.Accelerate]: "61697",
  [BringgFontIcons.AddLocationAlt]: "61698",
  [BringgFontIcons.AltRoute]: "61699",
  [BringgFontIcons.AnalyticsChart]: "61700",
  [BringgFontIcons.Analytics]: "61701",
  [BringgFontIcons.AreaChart]: "61702",
  [BringgFontIcons.ArrowDown]: "61703",
  [BringgFontIcons.ArrowLeft]: "61704",
  [BringgFontIcons.ArrowRight]: "61705",
  [BringgFontIcons.ArrowUp]: "61706",
  [BringgFontIcons.Arrow]: "61707",
  [BringgFontIcons.ArrowsUpDown]: "61708",
  [BringgFontIcons.Attachment]: "61709",
  [BringgFontIcons.AutoStories]: "61710",
  [BringgFontIcons.Autopay]: "61711",
  [BringgFontIcons.Barcode]: "61712",
  [BringgFontIcons.BarsFilter]: "61713",
  [BringgFontIcons.BatteryFull]: "61714",
  [BringgFontIcons.BatteryVerEmpty]: "61715",
  [BringgFontIcons.BatteryVerHalf]: "61716",
  [BringgFontIcons.BatteryVerQuarter]: "61717",
  [BringgFontIcons.BatteryVerThreeQuarters]: "61718",
  [BringgFontIcons.Bicycle]: "61719",
  [BringgFontIcons.Block]: "61720",
  [BringgFontIcons.BreakTo]: "61721",
  [BringgFontIcons.Bringg]: "61722",
  [BringgFontIcons.Bullseye]: "61723",
  [BringgFontIcons.Bus]: "61724",
  [BringgFontIcons.Business]: "61725",
  [BringgFontIcons.Busket]: "61726",
  [BringgFontIcons.CafeSolid]: "61727",
  [BringgFontIcons.Cafe]: "61728",
  [BringgFontIcons.Calendar]: "61729",
  [BringgFontIcons.Campaign]: "61730",
  [BringgFontIcons.Cancel]: "61731",
  [BringgFontIcons.Capacity]: "61732",
  [BringgFontIcons.Car]: "61733",
  [BringgFontIcons.Cart]: "61734",
  [BringgFontIcons.Cashier]: "61735",
  [BringgFontIcons.ChatBubble]: "61736",
  [BringgFontIcons.ChatBubbles]: "61737",
  [BringgFontIcons.Checklist]: "61738",
  [BringgFontIcons.ChevronLeft]: "61739",
  [BringgFontIcons.ChevronRight]: "61740",
  [BringgFontIcons.ChevronUp]: "61741",
  [BringgFontIcons.Chevron]: "61742",
  [BringgFontIcons.ChevronsEnd]: "61743",
  [BringgFontIcons.ChevronsStart]: "61744",
  [BringgFontIcons.CircleExclamation]: "61745",
  [BringgFontIcons.CirclePlus]: "61746",
  [BringgFontIcons.Circle]: "61747",
  [BringgFontIcons.ClockLight]: "61748",
  [BringgFontIcons.Clock]: "61749",
  [BringgFontIcons.CloseCircle]: "61750",
  [BringgFontIcons.Close]: "61751",
  [BringgFontIcons.Coins]: "61752",
  [BringgFontIcons.Colorize]: "61753",
  [BringgFontIcons.Columns]: "61754",
  [BringgFontIcons.Compare]: "61755",
  [BringgFontIcons.Compass]: "61756",
  [BringgFontIcons.Completed]: "61757",
  [BringgFontIcons.ConnectedHub]: "61758",
  [BringgFontIcons.ControlTower]: "61759",
  [BringgFontIcons.Copy]: "61760",
  [BringgFontIcons.CreateRoutePlus]: "61761",
  [BringgFontIcons.CreateRoute]: "61762",
  [BringgFontIcons.CreditCard]: "61763",
  [BringgFontIcons.Crew]: "61764",
  [BringgFontIcons.CsvFile]: "61765",
  [BringgFontIcons.Cube]: "61766",
  [BringgFontIcons.CustomerSdk]: "61767",
  [BringgFontIcons.Customer]: "61768",
  [BringgFontIcons.Cutoff]: "61769",
  [BringgFontIcons.DeliveryBlocks]: "61770",
  [BringgFontIcons.DeliverySlots]: "61771",
  [BringgFontIcons.DeployedCodeHistory]: "61772",
  [BringgFontIcons.DesignServices]: "61773",
  [BringgFontIcons.Dispatch]: "61774",
  [BringgFontIcons.Dispatchers]: "61775",
  [BringgFontIcons.Distance]: "61776",
  [BringgFontIcons.DistributionHub]: "61777",
  [BringgFontIcons.DocumenatationLink]: "61778",
  [BringgFontIcons.Document]: "61779",
  [BringgFontIcons.DonePlanning]: "61780",
  [BringgFontIcons.Dot]: "61781",
  [BringgFontIcons.Download]: "61782",
  [BringgFontIcons.Drag]: "61783",
  [BringgFontIcons.DriverHome]: "61784",
  [BringgFontIcons.DriversReturningToBase]: "61785",
  [BringgFontIcons.Drivers]: "61786",
  [BringgFontIcons.Dropoff]: "61787",
  [BringgFontIcons.Eco]: "61788",
  [BringgFontIcons.EditSquare]: "61789",
  [BringgFontIcons.Erase]: "61790",
  [BringgFontIcons.EventAvailable]: "61791",
  [BringgFontIcons.Expenses]: "61792",
  [BringgFontIcons.Export]: "61793",
  [BringgFontIcons.ExternalId]: "61794",
  [BringgFontIcons.ExternalLink]: "61795",
  [BringgFontIcons.EyeOff]: "61796",
  [BringgFontIcons.Eye]: "61797",
  [BringgFontIcons.Feather]: "61798",
  [BringgFontIcons.FileAlt]: "61799",
  [BringgFontIcons.FileImport]: "61800",
  [BringgFontIcons.File]: "61801",
  [BringgFontIcons.FilterHdr]: "61802",
  [BringgFontIcons.FilterList]: "61803",
  [BringgFontIcons.FlatTire]: "61804",
  [BringgFontIcons.FloatingInventory]: "61805",
  [BringgFontIcons.ForkLeftRightBack]: "61806",
  [BringgFontIcons.Forward]: "61807",
  [BringgFontIcons.Fragile]: "61808",
  [BringgFontIcons.Freeze]: "61809",
  [BringgFontIcons.Functions]: "61810",
  [BringgFontIcons.Globe]: "61811",
  [BringgFontIcons.GoToLink]: "61812",
  [BringgFontIcons.GraphOverview]: "61813",
  [BringgFontIcons.Graph]: "61814",
  [BringgFontIcons.GroupBy]: "61815",
  [BringgFontIcons.Hamburger]: "61816",
  [BringgFontIcons.HandPanMove]: "61817",
  [BringgFontIcons.HandPointingUp]: "61818",
  [BringgFontIcons.Headset]: "61819",
  [BringgFontIcons.HeartFilled]: "61820",
  [BringgFontIcons.Heart]: "61821",
  [BringgFontIcons.Help]: "61822",
  [BringgFontIcons.Home]: "61823",
  [BringgFontIcons.Hourglass]: "61824",
  [BringgFontIcons.Hub]: "61825",
  [BringgFontIcons.InfoFilled]: "61826",
  [BringgFontIcons.Info]: "61827",
  [BringgFontIcons.Inventory]: "61828",
  [BringgFontIcons.Json]: "61829",
  [BringgFontIcons.Keyboard]: "61830",
  [BringgFontIcons.Launch]: "61831",
  [BringgFontIcons.Layers]: "61832",
  [BringgFontIcons.LeafEco]: "61833",
  [BringgFontIcons.LibraryBooks]: "61834",
  [BringgFontIcons.Link]: "61835",
  [BringgFontIcons.List]: "61836",
  [BringgFontIcons.Loader]: "61837",
  [BringgFontIcons.LocalPolice]: "61838",
  [BringgFontIcons.LocalShipping]: "61839",
  [BringgFontIcons.Location]: "61840",
  [BringgFontIcons.Lock]: "61841",
  [BringgFontIcons.Locker]: "61842",
  [BringgFontIcons.Logout]: "61843",
  [BringgFontIcons.Man]: "61844",
  [BringgFontIcons.ManageHistory]: "61845",
  [BringgFontIcons.MapTask]: "61846",
  [BringgFontIcons.Map]: "61847",
  [BringgFontIcons.Maximize]: "61848",
  [BringgFontIcons.MenuHorizontal]: "61849",
  [BringgFontIcons.Menu]: "61850",
  [BringgFontIcons.MessageMail]: "61851",
  [BringgFontIcons.Minimize]: "61852",
  [BringgFontIcons.Minus]: "61853",
  [BringgFontIcons.MobileActionCompleteForm]: "61854",
  [BringgFontIcons.MobileActionQuestion]: "61855",
  [BringgFontIcons.Monitor]: "61856",
  [BringgFontIcons.MoveToDispatch]: "61857",
  [BringgFontIcons.MoveToPlanning]: "61858",
  [BringgFontIcons.MyLocation]: "61859",
  [BringgFontIcons.NavigationUp]: "61860",
  [BringgFontIcons.Navigation]: "61861",
  [BringgFontIcons.NoVehicle]: "61862",
  [BringgFontIcons.NoteLight]: "61863",
  [BringgFontIcons.Notes]: "61864",
  [BringgFontIcons.Notification]: "61865",
  [BringgFontIcons.OpenInNew]: "61866",
  [BringgFontIcons.Optimize]: "61867",
  [BringgFontIcons.Order]: "61868",
  [BringgFontIcons.OrderedList]: "61869",
  [BringgFontIcons.Package]: "61870",
  [BringgFontIcons.Pallets]: "61871",
  [BringgFontIcons.ParkingLocation]: "61872",
  [BringgFontIcons.PartnerExchange]: "61873",
  [BringgFontIcons.Pause]: "61874",
  [BringgFontIcons.PdfFile]: "61875",
  [BringgFontIcons.Pencil]: "61876",
  [BringgFontIcons.PhoneAndroid]: "61877",
  [BringgFontIcons.Phone]: "61878",
  [BringgFontIcons.Pickup]: "61879",
  [BringgFontIcons.Planning]: "61880",
  [BringgFontIcons.Play]: "61881",
  [BringgFontIcons.Plus]: "61882",
  [BringgFontIcons.Power]: "61883",
  [BringgFontIcons.Preferences]: "61884",
  [BringgFontIcons.PreparationRestaurant]: "61885",
  [BringgFontIcons.Preperation]: "61886",
  [BringgFontIcons.Print]: "61887",
  [BringgFontIcons.PrompedMessage]: "61888",
  [BringgFontIcons.Puzzle]: "61889",
  [BringgFontIcons.Radar]: "61890",
  [BringgFontIcons.Recipt]: "61891",
  [BringgFontIcons.RedoArrow]: "61892",
  [BringgFontIcons.Redo]: "61893",
  [BringgFontIcons.Reload]: "61894",
  [BringgFontIcons.Report]: "61895",
  [BringgFontIcons.Reschedule]: "61896",
  [BringgFontIcons.Resources]: "61897",
  [BringgFontIcons.Revenues]: "61898",
  [BringgFontIcons.Reviews]: "61899",
  [BringgFontIcons.RoSimulator]: "61900",
  [BringgFontIcons.Rotate]: "61901",
  [BringgFontIcons.RouteIdentifier]: "61902",
  [BringgFontIcons.Route]: "61903",
  [BringgFontIcons.Ruler]: "61904",
  [BringgFontIcons.SaveAs]: "61905",
  [BringgFontIcons.Save]: "61906",
  [BringgFontIcons.Scanner]: "61907",
  [BringgFontIcons.Search]: "61908",
  [BringgFontIcons.SelectedOutline]: "61909",
  [BringgFontIcons.Selected]: "61910",
  [BringgFontIcons.Send]: "61911",
  [BringgFontIcons.ServiceAreas]: "61912",
  [BringgFontIcons.SettingsSuggest]: "61913",
  [BringgFontIcons.Settings]: "61914",
  [BringgFontIcons.Share]: "61915",
  [BringgFontIcons.SheetWithDollar]: "61916",
  [BringgFontIcons.ShieldPerson]: "61917",
  [BringgFontIcons.ShowLess]: "61918",
  [BringgFontIcons.ShowMore]: "61919",
  [BringgFontIcons.Skills]: "61920",
  [BringgFontIcons.SmallCircle]: "61921",
  [BringgFontIcons.SortAsc]: "61922",
  [BringgFontIcons.SortDesc]: "61923",
  [BringgFontIcons.Sparkles]: "61924",
  [BringgFontIcons.Star]: "61925",
  [BringgFontIcons.StickyNote]: "61926",
  [BringgFontIcons.StopCircle]: "61927",
  [BringgFontIcons.Store]: "61928",
  [BringgFontIcons.Suffix]: "61929",
  [BringgFontIcons.Suitcase]: "61930",
  [BringgFontIcons.Support]: "61931",
  [BringgFontIcons.TakeoutDining]: "61932",
  [BringgFontIcons.TaskAlt]: "61933",
  [BringgFontIcons.TeamHome]: "61934",
  [BringgFontIcons.TeamParking]: "61935",
  [BringgFontIcons.Team]: "61936",
  [BringgFontIcons.TextBold]: "61937",
  [BringgFontIcons.TextItalic]: "61938",
  [BringgFontIcons.TextUnderline]: "61939",
  [BringgFontIcons.Ticket]: "61940",
  [BringgFontIcons.Traffic]: "61941",
  [BringgFontIcons.Trailer]: "61942",
  [BringgFontIcons.Trash]: "61943",
  [BringgFontIcons.Tree]: "61944",
  [BringgFontIcons.Truck]: "61945",
  [BringgFontIcons.Unassigned]: "61946",
  [BringgFontIcons.Unavailable]: "61947",
  [BringgFontIcons.UndoArrow]: "61948",
  [BringgFontIcons.Undo]: "61949",
  [BringgFontIcons.Unuser]: "61950",
  [BringgFontIcons.Upload]: "61951",
  [BringgFontIcons.User]: "61952",
  [BringgFontIcons.Users]: "61953",
  [BringgFontIcons.VerificationCode]: "61954",
  [BringgFontIcons.Warehouse]: "61955",
  [BringgFontIcons.WarningCircle]: "61956",
  [BringgFontIcons.WarningNotFilled]: "61957",
  [BringgFontIcons.Warning]: "61958",
  [BringgFontIcons.Weight]: "61959",
  [BringgFontIcons.Wheel]: "61960",
  [BringgFontIcons.ZoomIn]: "61961",
  [BringgFontIcons.ZoomOut]: "61962",
};
